import { find, findIndex, some } from "lodash";
import baseState from "./baseState";

export const actions = {
  clearProject({ commit }) {
    commit("updateProjectId", baseState.projectId);
    commit("updateProjectProperties", baseState.projectProperties);
    commit("updateConfiguration", baseState.configuration);
    commit("updatePous", baseState.pous);
    commit("updateDataTypes", baseState.dataTypes);
  },
  updateProject(
    { commit },
    { projectId, projectProperties, configuration, dataTypes, pous }
  ) {
    commit("updateProjectId", projectId);
    commit("updateProjectProperties", projectProperties);
    commit("updateConfiguration", configuration);
    commit("updateDataTypes", dataTypes);
    commit("updatePous", pous);
  },
  updateProjectProperties({ commit }, projectProperties) {
    commit("updateProjectProperties", projectProperties);
  },
  addVariable({ commit, state }, variable) {
    const globalVars = state.configuration.globalVars;
    globalVars.push(variable);
    commit("updateConfiguration", { globalVars });
  },
  updateVariable({ commit, state }, variable) {
    const index = findIndex(state.configuration.globalVars, {
      tempId: variable.tempId,
    });
    const globalVars = state.configuration.globalVars;
    globalVars.splice(index, 1, variable);
    commit("updateConfiguration", { globalVars });
  },
  deleteVariable({ commit, state }, variableTempId) {
    const index = findIndex(state.configuration.globalVars, {
      tempId: variableTempId,
    });
    const globalVars = state.configuration.globalVars;
    globalVars.splice(index, 1);
    commit("updateConfiguration", { globalVars });
  },
  addPou({ commit, state }, pou) {
    const pous = state.pous;
    pous.push(pou);
    commit("updatePous", pous);
  },
  updatePou({ commit, state }, pou) {
    const pous = state.pous;
    const index = findIndex(pous, { tempId: pou.tempId });

    const pouOldName = pous[index].name;
    if (pouOldName !== pou.name) {
      const resources = state.configuration.resources;
      for (const resource of resources) {
        const resourcePouInstanceIndex = findIndex(resource.pouInstances, { typeName: pouOldName })
        if (resourcePouInstanceIndex >= 0) {
          resource.pouInstances.splice(resourcePouInstanceIndex, 1, {
            ...resource.pouInstances[resourcePouInstanceIndex],
            typeName: pou.name,
          })
        }

        for (const task of resource.tasks) {
          const taskPouInstanceIndex = findIndex(task.pouInstances, { typeName: pouOldName });
          if (taskPouInstanceIndex >= 0) {
            task.pouInstances.splice(taskPouInstanceIndex, 1, {
              ...task.pouInstances[taskPouInstanceIndex],
              typeName: pou.name
            })
          }
        }
      }
  
      commit("updateConfiguration", { resources });
    }

    pous.splice(index, 1, pou);
    commit("updatePous", pous);
  },
  deletePou({ commit, state }, pouTempId) {
    const pous = state.pous;
    const index = findIndex(pous, { tempId: pouTempId });
    pous.splice(index, 1);
    commit("updatePous", pous);
  },
  addDataType({ commit, state }, dataType) {
    const dataTypes = state.dataTypes;
    dataTypes.push(dataType);
    commit("updateDataTypes", dataTypes);
  },
  updateDataType({ commit, state }, dataType) {
    const dataTypes = state.dataTypes;
    const index = findIndex(dataTypes, { tempId: dataType.tempId });
    dataTypes.splice(index, 1, dataType);
    commit("updateDataTypes", dataTypes);
  },
  deleteDataType({ commit, state }, dataTypeTempId) {
    const dataTypes = state.dataTypes;
    const index = findIndex(dataTypes, { tempId: dataTypeTempId });
    dataTypes.splice(index, 1);
    commit("updateDataTypes", dataTypes);
  },
  addPouVariable({ commit, state }, { pouTempId, variable }) {
    const pous = state.pous;
    const pou = find(pous, { tempId: pouTempId });
    pou.variables.push(variable);
    commit("updatePous", pous);
  },
  updatePouVariable({ commit, state }, { pouTempId, variable }) {
    const pous = state.pous;
    const pou = find(pous, { tempId: pouTempId });
    const index = findIndex(pou.variables, {
      tempId: variable.tempId,
    });
    pou.variables.splice(index, 1, variable);
    commit("updatePous", pous);
  },
  deletePouVariable({ commit, state }, { pouTempId, variableTempId }) {
    const pous = state.pous;
    const pou = find(pous, { tempId: pouTempId });
    const index = findIndex(pou.variables, {
      tempId: variableTempId,
    });
    pou.variables.splice(index, 1);
    commit("updatePous", pous);
  },
  addResource({ commit, state }, resource) {
    const resources = state.configuration.resources;
    resources.push(resource);
    commit("updateConfiguration", { resources });
  },
  updateResource({ commit, state }, resource) {
    const resources = state.configuration.resources;
    const index = findIndex(resources, { tempId: resource.tempId });
    resources.splice(index, 1, resource);
    commit("updateConfiguration", { resources });
  },
  deleteResource({ commit, state }, resourceTempId) {
    const resources = state.configuration.resources;
    const index = findIndex(resources, { tempId: resourceTempId });
    resources.splice(index, 1);
    commit("updateConfiguration", { resources });
  },
  addResourceVariable({ commit, state }, { resourceTempId, variable }) {
    const resources = state.configuration.resources;
    const resource = find(resources, { tempId: resourceTempId });
    resource.globalVars.push(variable);
    commit("updateConfiguration", { resources });
  },
  updateResourceVariable({ commit, state }, { resourceTempId, variable }) {
    const resources = state.configuration.resources;
    const resource = find(resources, { tempId: resourceTempId });
    const index = findIndex(resource.globalVars, {
      tempId: variable.tempId,
    });
    resource.globalVars.splice(index, 1, variable);
    commit("updateConfiguration", { resources });
  },
  deleteResourceVariable(
    { commit, state },
    { resourceTempId, variableTempId }
  ) {
    const resources = state.configuration.resources;
    const resource = find(resources, { tempId: resourceTempId });
    const index = findIndex(resource.globalVars, {
      tempId: variableTempId,
    });
    resource.globalVars.splice(index, 1);
    commit("updateConfiguration", { resources });
  },
  addResourceTask({ commit, state }, { resourceTempId, task }) {
    const resources = state.configuration.resources;
    const resource = find(resources, { tempId: resourceTempId });
    resource.tasks.push(task);
    commit("updateConfiguration", { resources });
  },
  updateResourceTask({ commit, state }, { resourceTempId, task }) {
    const resources = state.configuration.resources;
    const resource = find(resources, { tempId: resourceTempId });
    const index = findIndex(resource.tasks, {
      tempId: task.tempId,
    });
    resource.tasks.splice(index, 1, task);
    commit("updateConfiguration", { resources });
  },
  deleteResourceTask({ commit, state }, { resourceTempId, taskTempId }) {
    const resources = state.configuration.resources;
    const resource = find(resources, { tempId: resourceTempId });
    const index = findIndex(resource.tasks, {
      tempId: taskTempId,
    });
    resource.tasks.splice(index, 1);
    commit("updateConfiguration", { resources });
  },
  addResourcePouInstance({ commit, state }, { resourceTempId, pouInstance }) {
    const resources = state.configuration.resources;
    const resource = find(resources, { tempId: resourceTempId });
    resource.pouInstances.push(pouInstance);
    commit("updateConfiguration", { resources });
  },
  updateResourcePouInstance(
    { commit, state },
    { resourceTempId, pouInstance }
  ) {
    const resources = state.configuration.resources;
    const resource = find(resources, { tempId: resourceTempId });

    const index = findIndex(resource.pouInstances, {
      tempId: pouInstance.tempId,
    });

    if (index < 0) {
      // pou instance move from task to resource
      // Delete pou instance in task and create new one in resource

      for (const task in resource.tasks) {
        const taskPouInstanceIndex = findIndex(task.pouInstances, {
          tempId: pouInstance.tempId,
        });

        if (taskPouInstanceIndex >= 0) {
          task.pouInstances.splice(taskPouInstanceIndex, 1);
          break;
        }
      }

      resource.pouInstances.push({
        ...pouInstance,
        id: undefined,
      });
    } else {
      resource.pouInstances.splice(index, 1, pouInstance);
    }

    commit("updateConfiguration", { resources });
  },
  deleteResourcePouInstance(
    { commit, state },
    { resourceTempId, pouInstanceTempId }
  ) {
    const resources = state.configuration.resources;
    const resource = find(resources, { tempId: resourceTempId });
    const index = findIndex(resource.pouInstances, {
      tempId: pouInstanceTempId,
    });
    resource.pouInstances.splice(index, 1);
    commit("updateConfiguration", { resources });
  },
  addResourceTaskPouInstance(
    { commit, state },
    { resourceTempId, taskTempId, pouInstance }
  ) {
    const resources = state.configuration.resources;
    const resource = find(resources, { tempId: resourceTempId });
    const task = find(resource.tasks, { tempId: taskTempId });
    task.pouInstances.push(pouInstance);
    commit("updateConfiguration", { resources });
  },
  updateResourceTaskPouInstance(
    { commit, state },
    { resourceTempId, taskTempId, pouInstance }
  ) {
    const resources = state.configuration.resources;
    const resource = find(resources, { tempId: resourceTempId });
    const task = find(resource.tasks, { tempId: taskTempId });
    const index = findIndex(task.pouInstances, {
      tempId: pouInstance.tempId,
    });

    if (index < 0) {
      // Pou instance move from resource or other task
      // Delete pou instance in resource or other task, then create new one in current task

      const resourcePouInstanceIndex = findIndex(resource.pouInstances, {
        tempId: pouInstance.tempId,
      });

      if (resourcePouInstanceIndex < 0) {
        // pou instance move from other task
        // Delete pou instance in other task

        for (const t of resource.tasks) {
          const taskPouInstanceIndex = findIndex(t.pouInstances, {
            tempId: pouInstance.tempId,
          });

          if (taskPouInstanceIndex >= 0) {
            t.pouInstances.splice(taskPouInstanceIndex, 1);
            break;
          }
        }
      } else {
        // pou instance move from resource
        resource.pouInstances.splice(resourcePouInstanceIndex, 1);
      }

      // Add new instance to current task
      task.pouInstances.push({
        ...pouInstance,
        id: undefined,
      });
    } else {
      task.pouInstances.splice(index, 1, pouInstance);
    }

    commit("updateConfiguration", { resources });
  },
  deleteResourceTaskPouInstance(
    { commit, state },
    { resourceTempId, taskTempId, pouInstanceTempId }
  ) {
    const resources = state.configuration.resources;
    const resource = find(resources, { tempId: resourceTempId });
    const task = find(resource.tasks, { tempId: taskTempId });
    const index = findIndex(task.pouInstances, {
      tempId: pouInstanceTempId,
    });
    task.pouInstances.splice(index, 1);
    commit("updateConfiguration", { resources });
  },

  updateAddItem({ commit }, addItem) {
    commit("updateAddItem", addItem);
  },
  clearAddItem({ commit }) {
    commit("updateAddItem", baseState.addItem);
  },

  updateShowLoading({ commit }, showLoading) {
    commit("updateShowLoading", showLoading);
  },
};
